export const DEMO_FILES = {
  local: "/sample.gpx",
  cycle: "https://cartio-demo-files.s3.eu-west-1.amazonaws.com/cycle.gpx",
  hike: "https://cartio-demo-files.s3.eu-west-1.amazonaws.com/hike.gpx",
  run: "https://cartio-demo-files.s3.eu-west-1.amazonaws.com/run.gpx",
};
